import { isIOS, getShared, p2 } from '../vodjs/Utils';
import { elasticLogConfig, elasticLogEvent, elasticLogError, netLog } from '../vodjs/ElasticLog';
import { localNoise } from './localSounds';
import sleep from 'sleep-promise';

//https://stackoverflow.com/questions/31776548/why-cant-javascript-play-audio-files-on-iphone-safari
let iosAudioEl;
export const briefSilence = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';

const ios = false; //isIOS(); seems this differentiator no longer needed with expo in the rearview...

let doDbAlerts = false; //debug

export const arrivalSoundName = 'noise';

const UNSILENCE_MP3 = 'unsilence.mp3';

let prevSoundInfo = undefined;

let deferredSound = undefined;
let netLoadPlaying = undefined;

let bufferTable = {};
let triedAudioCtx = false;
let resumingAudio = false;
let gAudioContext;
// const continuousResume = true;

const getSoundName = sound => {

  if(sound == briefSilence)
    return 'briefSilence';

  if(sound == localNoise)
    return 'localNoise';

  if(typeof(sound) != 'string')
    return 'bad type: ' + typeof(sound);

  return sound.slice(0, 40);
};

//https://errorsandanswers.com/how-to-check-if-html5-audio-has-reached-different-errors/
const mediaErrLabels = [
  '',
  'MEDIA_ERR_ABORTED',
  'MEDIA_ERR_NETWORK',
  'MEDIA_ERR_DECODE',
  'MEDIA_ERR_SRC_NOT_SUPPORTED',
];


function dbAlert(msg) {
  if(doDbAlerts) alert(msg);
}


//pre-load and pre-decode sound resources
async function populateBufferTable() {
  let soundNames = [UNSILENCE_MP3, 'ding.mp3', 'peal.mp3', 'noise.mp3'];

  const getNotLoaded = () => soundNames.filter(soundName => !bufferTable[soundName]);

  let notYetLoaded = getNotLoaded();
  for(let soundName of notYetLoaded) {

    if(bufferTable[soundName]) continue;

    let abortController = new AbortController();
    let signal = abortController.signal;
    let options = {signal};
    let timer = setTimeout(() => abortController.abort(), 1000 * 15);  //timeout after a few seconds

    let response;
    try {
      response = await fetch(soundName, options);
    }
    catch(err) {
      elasticLogError({what:'loadSoundErr', msg:`populateBufferTable: Error loading sound ${soundName}: ` + err}, `loadSoundErr:${soundName}`);
    }
    clearTimeout(timer);
    if (!response?.ok) {
      elasticLogError({what:'loadSoundNotOk', msg:`populateBufferTable: response${!response ? '' : ' ok'} falsey loading ${soundName}`}, `loadSoundNotOk:${soundName}`);
      continue;
    }

    const arrayBuffer = await response.arrayBuffer();

    let MyAudioContext = window.AudioContext || window.webkitAudioContext;
    if(!MyAudioContext) {
      elasticLogError({what:'noAudioCtx', msg:`populateBufferTable: No audio context`});
      return;
    }
    const audioContext = new MyAudioContext();
    await audioContext.decodeAudioData(arrayBuffer, result => bufferTable[soundName] = result);
  }

  let notLoaded = getNotLoaded();
  if(notLoaded.length) {
    elasticLogError({what:'popSoundIncomplete', msg:`populateBufferTable: Not yet loaded: ${notLoaded.join(', ')}`}, 'popSoundIncomplete');
    setTimeout(populateBufferTable, 1000 * 30); //try again in a bit
  }
  else {
    elasticLogEvent({what:'soundsLoaded', msg: `populateBufferTable: All sounds are now loaded.`});
  }
}



export default class Audio {
  //call for IOS; needs to be called in response to early user interaction
  static init() {

    populateBufferTable();

    if (iosAudioEl || !ios) return;

    elasticLogEvent({ what: 'iosAudio', msg: `Using codepath for ios audio.` });

    iosAudioEl = document.createElement('audio');
    // iosAudioEl.addEventListener("load", () => iosAudioEl.play(), true);
    // iosAudioEl.src = briefSilence;

    // iosAudioEl.addEventListener('canplaythrough', () => iosAudioEl.play(), false);
  }

  static playSound(sound, playerEl) {

    if (playerEl && !playerEl._addedErrListener) {
      playerEl._addedErrListener = true;
      playerEl.addEventListener('error', (e) => {
        let code = e.target.error.code;
        let label = mediaErrLabels[code] || '';
        let origLabel = label;
        if (label.indexOf('not allowed') >= 0)
          label = '(not allowed)';
        let msg = `Error playing sound ${soundName}: ${code} ${label}`;
        elasticLogError({ what: 'sndErr', msg, origLabel });
      });
    }

    let soundIsSilence = (sound == briefSilence);

    if(soundIsSilence && getShared().autoPrioConfig?.unsilence) {
      sound = UNSILENCE_MP3;
      soundIsSilence = false;
    }

    let soundName = getSoundName(sound);

    let netLoadSounds = getShared().autoPrioConfig?.netLoadSounds;

    //allocate gAudioContext in the first sound play thread
    if(!triedAudioCtx) {
      triedAudioCtx = true;

      let MyAudioContext = window.AudioContext || window.webkitAudioContext;
      gAudioContext = new MyAudioContext();
      if(!gAudioContext) {
        elasticLogError({ what: 'audCtxNoNew', msg: `during ${soundName}, new of AudioContext gave falsey result` }, 'audCtxNoNew');
        dbAlert(`debug: no audioCtx for ${soundName}`);
      }
      else {
        //play in the converse channel of whatever mode we're in, to initialize in case we switch later

        if(netLoadSounds) {
          //we're in netLoad mode, so converse is buffered
          playBufferedSound(UNSILENCE_MP3);
        }
        else {
          //we're in buffered mode, so converse is netLoad
          playNetLoadedSound(UNSILENCE_MP3, playerEl)
        }
      }
    }
    // else if(netLoadSounds && gAudioContext) {
    //   playBufferedSound(UNSILENCE_MP3); //experimental keep-alive
    // }


    elasticLogEvent({ what: 'soundPlay', msg: `Playing sound ${soundName}.` });

    //debounce
    let when = Date.now();
    if (prevSoundInfo && when - prevSoundInfo.when < 1000 && prevSoundInfo.sound == sound) {
      console.log('Suppressing redundant sound bc too soon: ' + soundName);
      elasticLogEvent({ what: 'sndSuppress', msg: `Suppressing sound ${soundName} bc recently played.` });
      return;
    }
    prevSoundInfo = { when, sound };

    try {
      if (iosAudioEl) {
        iosAudioEl.src = sound;
        iosAudioEl.play();
      }
      else if (playerEl) {
        //needed for Android; seems to work fine for desktop

        if(!netLoadSounds && !gAudioContext) {
          netLoadSounds = true;
          elasticLogError({ what: 'forcedNetLoadAudio', msg: `Cornered into net-loading audio for ${soundName}` });
        }

        if (netLoadSounds && netLoadPlaying) {

          let ticksAgo = Date.now() - netLoadPlaying.when;
          if(ticksAgo < 1000 * 10) {
            elasticLogEvent({ what: 'sndDefer', msg: `Deferring ${soundName} because playing ${netLoadPlaying.soundName}.` });
            deferredSound = sound;
            return; //250430
          }

          elasticLogError({ what: 'audLongDefer', msg: `Audio claims playing ${netLoadPlaying.soundName} but was ${Math.round(ticksAgo / 100)/10}s ago; overriding` });
          netLoadPlaying = undefined;
          //fall through
        }

        //failsafe
        if(deferredSound) {
          //should have been cleared out elsewhere
          elasticLogError({ what: 'audOverClear', msg: `Doing failsafe clearout of deferredSound ${getSoundName(deferredSound)}` });
          deferredSound = undefined;
        }

        try {
          if(netLoadSounds) {
            playNetLoadedSound(soundName, playerEl)
          }
          else {
            playBufferedSound(soundName);
          }
        }
        catch(err) {
          dbAlert(`debug: top catch for ${soundName}: ` + err);
          elasticLogError({ what: 'audTopCatch', msg: `Audio top-level catch: ` + err }, 'audTopCatch');
        }

      }
      else {
        //nominal path for desktop (though desktop for now probably shunted to Android path above)

        elasticLogError({ what: 'noAudioEl', msg: `playSound: No audio element was supplied!` });

        let audio = new Audio(sound);
        audio.autoplay = true;
        audio.play();
      }
    }
    catch (err) {
      console.log('Could not play sound: ' + err);
    }
  }
}


function playNetLoadedSound(soundName, playerEl) {

  if(!playerEl) {
    elasticLogError({ what: 'audNoEl', msg: `No player element during ${soundName}` });
    return;
  }

  playerEl.src = soundName; //LMR sound
  playerEl.load();

  const playPromise = playerEl.play();
  if(!playPromise) {
    elasticLogError({ what: 'audNoProm', msg: `Got no playPromise attempting ${soundName}` });
    return;
  }

  const when = Date.now();
  netLoadPlaying = {soundName, when};
  playPromise.playingCopy = {...netLoadPlaying};

  playPromise.then(() => {
    //success?  //250430 netLoadPlaying = sound;
    if(!netLoadPlaying)
      elasticLogError({ what: 'audFalsyPlaying', msg: `in .then, playing was falsey for ${soundName}`});
    else
      elasticLogEvent({ what: 'audThen', msg: `Done playing ${netLoadPlaying.soundName}` });

    netLoadPlaying = undefined;

  })
  .catch(error => {

    let msgParts = [`Error during play of ${netLoadPlaying?.soundName || '(missing)'}: ` + error];
    if(netLoadPlaying) {
      if(netLoadPlaying.when != when)
        msgParts.push(`playing.when(${netLoadPlaying.when}) != when(${when})`);

      let soundNameCopy = playPromise.playingCopy?.soundName;
      if(soundNameCopy && soundNameCopy != netLoadPlaying.soundName)
        msgParts.push( `soundNameCopy(${soundNameCopy} != netLoadPlaying.soundName(${netLoadPlaying.soundName})`);
    }
    elasticLogError({ what: 'audAsyncCatch', msg: msgParts.join('; ')});
    
    netLoadPlaying = undefined;
  })
  .finally(() => {
    if (deferredSound) {
      elasticLogEvent({ what: 'playDeferred', msg: `Playing deferred sound ${getSoundName(deferredSound)}` });
      let tmpSound = deferredSound;
      deferredSound = undefined;
      Audio.playSound(tmpSound, playerEl);
    }
  });
}




function playBufferedSound(soundName, isRecursive) {

  if(!bufferTable[soundName]) {
    elasticLogError({ what: 'noAudioTableEntry', msg: `there is no audio table entry for ${soundName}` }, 'audBufSrcErr');
    console.log(`playBufferedSound: Didn't have table entry for ${soundName}`);
    return;
  }

  let source;
  try {
    source = gAudioContext.createBufferSource();
  }
  catch(err) {
    elasticLogError({ what: 'audBufSrcErr', msg: `during ${soundName}, caught an error from createBufferSource: ` + err }, 'audBufSrcErr');
    return;
  }
  source.buffer = bufferTable[soundName];
  source.connect(gAudioContext.destination);
  source.start();

  //prevent resource leak?
  setTimeout(() => {
    try {
      source.disconnect(gAudioContext.destination);
    }
    catch(err) {
      elasticLogError({ what: 'audDisconnErr', msg: `Error post-play disconnecting audio source: ` + err }, 'audDisconnErr');
    }
  }, 1000 * 10);
}
